export const STREETS = Object.freeze({
  Abelenstraat: "hof-van-rieth",
  "Alice Nahonlei": "oude-god",
  "Amedeus Stockmanslei": "dieseghem",
  "Anna van Hoornstraat": "dieseghem",
  Antwerpsestraat: [
    { value: "oude-god", odd: true, min: 3, max: 85 },
    { value: "oude-god", even: true, min: 2, max: 86 },
    { value: "geveart", odd: true, min: 89, max: 291 },
    { value: "geveart", even: true, min: 96, max: 296 },
  ],
  "Armand Segerslei": "oude-god",
  Beekstraat: "oude-god",
  "Berten Pilstraat": "savelkoul",
  Berthoutstraat: "geveart",
  Blauwbroedersstraat: "hof-van-rieth",
  Bloemenlei: "geveart",
  Bosstraat: "oude-god",
  Cantecroylaan: "fort-4",
  "Christus Koninglaan": "hof-van-rieth",
  Cogelslei: "dieseghem",
  "Cornelis De Herdtstraat": "hof-van-rieth",
  Damhertenlaan: "geveart",
  "De Donk": "savelkoul",
  "De Stappe": "sint-jozef",
  "De Valk": "sint-jozef",
  Deurneleitje: "geveart",
  Deurnestraat: [
    { value: "geveart", odd: true, min: 1, max: 163 },
    { value: "geveart", even: true, min: 4, max: 200 },
    { value: "dieseghem", odd: true, min: 187, max: 343 },
    { value: "dieseghem", even: true, min: 206, max: 252 },
  ],
  Dieseghemlei: [
    { min: 1, max: 13, odd: true, value: "geveart" },
    { min: 2, max: 22, even: true, value: "geveart" },
    { min: 19, max: 97, odd: true, value: "dieseghem" },
    { min: 24, max: 126, even: true, value: "dieseghem" },
  ],
  Doolhoflaan: "hof-van-rieth",
  Drabstraat: "fort-4",
  Edegemsestraat: [
    { min: 1, max: 141, odd: true, value: "oude-god" },
    { min: 2, max: 132, even: true, value: "oude-god" },
    { min: 149, max: 273, odd: true, value: "hof-van-rieth" },
  ],
  "Edmond Thieffrylaan": [
    { min: 1, max: 109, odd: true, value: "oude-god" },
    { min: 2, max: 140, even: true, value: "hof-van-rieth" },
  ],
  "Eduard Arsenstraat": "oude-god",
  Eesterbos: "geveart",
  Eggestraat: "oude-god",
  "Elf-julistraat": "mortsel-dorp",
  Ellebroecken: "geveart",
  Elzenplein: "oude-god",
  Floralaan: "hof-van-rieth",
  "Floris de Cuijperstraat": "geveart",
  Fortstraat: "fort-4",
  Gasthuishoeven: "fort-4",
  Gemeenteplein: "oude-god",
  Goudenregen: "fort-4",
  "Graaf d'Urselstraat": "dieseghem",
  "Graaf Witgerstraat": "dieseghem",
  Grensbeeklaan: "geveart",
  Grotenhof: "oude-god",
  "Guido Gezellelaan": "geveart",
  "Gustaaf Lavastraat": "oude-god",
  Haleblok: "hof-van-rieth",
  Halmrodelaan: "dieseghem",
  Heideland: "geveart",
  "Heilig-Kruisstraat": "oude-god",
  Heirbaan: "fort-4",
  Heldenhuldelaan: "fort-4",
  "Hendrik Consciencelaan": "geveart",
  "Hendrik Kuijpersstraat": "geveart",
  "Herman Ullenslei": "dieseghem",
  "Het Prieel": "dieseghem",
  "Hof Savelkoul": "savelkoul",
  "Hof ter Linden": "mortsel-dorp",
  "Hof van Riethlaan": "hof-van-rieth",
  "Hollandse Tuin": "mortsel-dorp",
  Ijzerenweglei: "fort-4",
  "Jaak Blockxstraat": "geveart",
  "Jacob van Arteveldestraat": "mortsel-dorp",
  "Jozef Hermanslei": "geveart",
  "Juliaan De Vriendtstraat": "oude-god",
  Kapellelei: "dieseghem",
  "Kardinaal Cardijnlaan": "savelkoul",
  "Klein Zwitserland": "fort-4",
  Krijgsbaan: [
    { min: 3, max: 51, odd: true, value: "fort-4" },
    { min: 134, max: 206, even: true, value: "fort-4" },
    { min: 54, max: 132, even: true, value: "oude-god" },
  ],
  Kunstambachtslaan: "geveart",
  Laathof: "dieseghem",

  "Lieve Gruyaertstraat": "savelkoul",
  "Lieven Gevaertstraat": "geveart",
  Lindenlei: "oude-god",
  "Lode Vissenaekenstraat": "geveart",
  "Lodewijk Dosfellei": "fort-4",
  Luithagenlaan: "geveart",
  Lusthovenlaan: "oude-god",
  Maalderijstraat: "hof-van-rieth",
  "Maria Gorettistraat": "savelkoul",
  Maxlaan: "fort-4",
  Mechelsesteenweg: [
    { min: 7, max: 77, odd: true, value: "oude-god" },
    { min: 2, max: 134, even: true, value: "oude-god" },
    { min: 85, max: 199, odd: true, value: "hof-van-rieth" },
    { min: 140, max: 192, even: true, value: "hof-van-rieth" },
  ],
  Meidoorn: "fort-4",
  Minervastraat: "oude-god",
  Molenlei: "hof-van-rieth",
  Molenstraat: [
    { min: 1, max: 3, odd: true, value: "mortsel-dorp" },
    { min: 4, max: 52, even: true, value: "mortsel-dorp" },
    { min: 43, max: 83, odd: true, value: "hof-van-rieth" },
    { min: 60, max: 188, even: true, value: "hof-van-rieth" },
  ],
  Mortselveldenlaan: "hof-van-rieth",
  Neerhoevelaan: "fort-4",
  Neuris: "geveart",
  Oosterveldlaan: "geveart",
  Osylei: "dieseghem",
  Oudebaan: "hof-van-rieth",
  Pansgatelaan: "dieseghem",
  "Park Mayerlei": "sint-jozef",
  "Park Oude God": "oude-god",
  "Pastoor de Tiliastraat": "savelkoul",
  "Pastoor Deensstraat": "savelkoul",
  "Pastoor Michielsensstraat": "mortsel-dorp",
  "Pastoor Soeteweystraat": "savelkoul",
  "Pastoor Van der Auwerastraat": "sint-jozef",
  "Pater Renaat De Vosstraat": "savelkoul",
  "Pieter Reypenslei": "oude-god",
  "Priester Poppestraat": "savelkoul",
  "Prins Leopoldlei": [
    { value: "hof-van-rieth", odd: true, min: 1, max: 99 },
    { value: "oude-god", even: true, min: 2, max: 106 },
  ],
  "Quinten Matsijslei": "mortsel-dorp",
  "Ridder van Ranstlei": "geveart",
  Rietveld: "geveart",
  "Rode Beuk": "fort-4",
  "Rode Leeuwlaan": "dieseghem",
  Roderveldlaan: "geveart",
  Rozentuin: "fort-4",
  Rubensstraat: [
    { min: 1, max: 39, odd: true, value: "mortsel-dorp" },
    { min: 2, max: 52, even: true, value: "mortsel-dorp" },
    { value: "sint-jozef", min: 47, max: 109, odd: true },
    { value: "sint-jozef", min: 54, max: 88, even: true },
  ],
  Saffierstraat: "dieseghem",
  Selland: "hof-van-rieth",
  Septestraat: "geveart",
  Singel: "hof-van-rieth",
  "Sint-Annalei": "geveart",
  "Sint-Benedictusstraat": "mortsel-dorp",
  "Sint-Bernadettestraat": "hof-van-rieth",
  "Sint-Hathebrandstraat": "hof-van-rieth",
  "Sint-Reinhildisstraat": "dieseghem",
  Speeltuinlaan: "geveart",
  Stadsplein: "fort-4",
  Statielei: "oude-god",
  Steenakker: "fort-4",
  Steenovenbos: "fort-4",
  "Ten Dorpelei": "geveart",
  "Ter Varentstraat": "geveart",
  "Theofiel Reynlaan": "geveart",
  Tommeltlaan: "hof-van-rieth",
  "Van Dijckstraat": [
    { value: "sint-jozef", min: 41, max: 123, odd: true },
    { value: "sint-jozef", min: 40, max: 142, even: true },
    { value: "mortsel-dorp", odd: true, min: 1, max: 35 },
    { value: "mortsel-dorp", even: true, min: 6, max: 34 },
  ],
  "Van Peborghlei": "oude-god",
  "Vijf-aprilwarande": "oude-god",
  Voorspoedlei: "geveart",
  Vredebaan: "oude-god",
  Vuurkruisenlaan: "fort-4",
  Waesdonckstraat: "dieseghem",
  "Walter Pompelaan": "hof-van-rieth",
  Weerstandsplein: "fort-4",
  Weidestraat: "oude-god",
  Willaard: "hof-van-rieth",
  Windhoek: "hof-van-rieth",
  "Wouter Volcaertstraat": "dieseghem",
  Wouwstraat: [
    { min: 3, max: 39, odd: true, value: "mortsel-dorp" },
    { min: 4, max: 36, even: true, value: "mortsel-dorp" },
    { min: 47, max: 183, odd: true, value: "sint-jozef" },
    { value: "sint-jozef", min: 47, max: 183, odd: true },
  ],
  Zaaldenrode: "fort-4",
  Zilverbeeklaan: "dieseghem",
  Boechoutselei: "sint-jozef",
  Borsbeeksebinnenweg: "mortsel-dorp",
  Bremveldlaan: "sint-jozef",
  Dorpsstraat: "mortsel-dorp",
  Fredericusstraat: "sint-jozef",
  Ganzennest: "sint-jozef",
  Groenstraat: "mortsel-dorp",
  Jordaenslei: "mortsel-dorp",
  Kapenbergstraat: "sint-jozef",
  Kaphaanlei: "sint-jozef",
  Kerkstraat: "mortsel-dorp",
  Koeisteerthofdreef: "savelkoul",
  Kretenburgstraat: "sint-jozef",
  Lepelstraat: "mortsel-dorp",
  Liersesteenweg: [
    { value: "savelkoul", min: 187, max: 327, odd: true },
    { value: "sint-jozef", min: 178, max: 340, even: true },
    { value: "mortsel-dorp", min: 2, max: 176, even: true },
    { value: "fort-4", min: 19, max: 185, odd: true },
  ],
  Lobbesplein: "savelkoul",
  Mayerlei: "sint-jozef",
  Meerminne: "mortsel-dorp",
  Nieuwelei: "sint-jozef",
  Pasteelsstraat: "mortsel-dorp",
  Veldbloemstraat: "sint-jozef",
  Vestinglaan: "mortsel-dorp",
  Vlaslaan: "sint-jozef",
  Wolschaerderveldenstraat: "sint-jozef",
});
